/**
 * Convert JS Date object to a string acceptable by the API (YYYY-MM-DD HH:mm:ss).
 */
export function convertDateToApiFormat(date: Date): string {
  const pad = (n: number): string => String(n).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
